<template>
  <div>
    <!-- header -->
    <HeadBar @nameClick = "nameClick"></HeadBar>
    <div class="conent-box">
        <el-form ref="searchForm" :inline="true" :model="queryParam" class="demo-form-inline" :rules="searchRules">
            <el-form-item label="身份证号:" prop="idCard">
                <el-input v-model="queryParam.idCard" placeholder="按身份证号搜索" maxLength="18"></el-input>
            </el-form-item>
            <!--<el-form-item label="手机号:" prop="phone">-->
                <!--<el-input v-model="queryParam.phone" placeholder="按手机号搜索" maxLength="11"></el-input>-->
            <!--</el-form-item>-->
            <el-form-item>
                <el-select v-model="queryParam.isExist">
                    <el-option label="已存在手机号" value="1"></el-option>
                    <el-option label="未存在手机号" value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSearch">搜 索</el-button>
            </el-form-item>
        </el-form>
        <el-form>
            <div style="text-align: left;">
                <div style="display:inline-block;width:300px;vertical-align: top">
                    <el-form-item label="批量导入:">
                        <el-upload
                                ref="upload"
                                :action="this.global.baseUrl +'/tCyAccountConfig/uploadExcel'"
                                accept=".xls,.xlsx"
                                :on-success="updataSuccess"
                                :on-error="updataError"
                                :file-list="fileList"
                                :auto-upload="false"
                                :before-upload="beforeAvatarUpload"
                                :limit="1">
                            <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
                            <el-button style="margin-left: 10px;" size="small" type="primary" @click="submitUpload">开始导入</el-button>
                        </el-upload>
                    </el-form-item>
                </div>
                <div style="display:inline-block;width:400px;font-size: 14px;color: #666;" v-show="fileTips.isShow">
                    <div>
                        导入完成，共导入{{fileTips.totalCount}}条，成功{{fileTips.successCount}}条，失败{{fileTips.failedCount}}条。
                    </div>
                    <div v-show="fileTips.failedCount>0">
                        请下载导入失败数据文件，按提示调整后重新完成导入<br><el-button type="text" @click="downError">下载导入失败数据文件</el-button>
                    </div>
                </div>
                <div style="float: right;">
                    <el-button type="text" @click="downModel">批量导入模板下载</el-button>
                </div>
            </div>
        </el-form>

      <!--表格-->
      <el-table
              :data="pageResult"
              v-loading="loading" element-loading-text="拼命加载中"
              style="width: 100%">
        <el-table-column
                prop="loginName"
                label="身份证号"
                align="center">
        </el-table-column>
        <el-table-column
                prop="mobilePhone"
                label="手机号"
                align="center">
        </el-table-column>
        <el-table-column
                label="操作"
                align="center"
                width="150"
        >
          <template slot-scope="scope">
            <el-button @click="editClick(scope.row)" type="text" size="small">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="total, prev, pager, next, jumper" @current-change="refreshPageRequest"
                     :current-page="pageRequest.pageNum" :page-size="pageRequest.pageSize" :total="pageRequest.total" style="float:right;">
      </el-pagination>
    </div>
    <!--修改弹窗-->
    <el-dialog
          title="修改"
          :visible.sync="dialogForm.open"
          width="30%">
        <el-form ref="dialogForm2" :model="rowData" label-width="90px" :rules="dialogRules">
            <el-form-item label="身份证号：" prop="idCard">
                <div style="text-align: left;">{{rowData.loginName}}</div>
            </el-form-item>
            <el-form-item label="手机号：" prop="mobilePhone">
                <el-input v-model="rowData.mobilePhone" maxLength="11"></el-input>
            </el-form-item>
        </el-form>
       <span slot="footer" class="dialog-footer">
            <el-button @click="dialogForm.open = false">取 消</el-button>
            <el-button type="primary" @click="editDialogSubmit">确 定</el-button>
       </span>
  </el-dialog>
  </div>
</template>

<script>
    import HeadBar from '@/components/HeadBar';
    import KtTable from "@/components/KtTable"
    import { format } from "@/utils/datetime"
    import Cookies from 'js-cookie'
    export default {
        components:{
            HeadBar,
            KtTable
        },
        name: 'Mobile',
        data() {
            let validateIdCard = (rule, value, callback) => {
                if (value && (!(/\d{17}[\d|x]|\d{15}/).test(value) || (value.length !== 15 && value.length !== 18))) {
                    callback(new Error('身份证号码不符合规范'))
                } else {
                    callback()
                }
            };
            let phoneNumber = (rule, value, callback) =>  {
                if (value && (!(/^[1][3456789]\d{9}$/).test(value) || !(/^[1-9]\d*$/).test(value) || value.length !== 11)) {
                    callback(new Error('手机号码不符合规范'))
                } else {
                    callback()
                }
            };
            return {
                loading:false,
                columns: [
                    {prop:"loginName", label:"身份证号", minWidth:100},
                    {prop:"mobilePhone", label:"手机号", minWidth:100},
                    {label:"操作", minWidth:80},
                ],
                queryParam:{
                    pageNum: 1,
                    pageSize: 10,
                    companyId:'',
                    idCard:'',
                    phone:'',
                    isExist:'0'
                },
                searchRules:{
                    idCard: [
                        { validator: validateIdCard, trigger: 'blur'}
                    ],
                    phone:[
                        { validator: phoneNumber, trigger: 'blur'}
                    ]
                },
                pageRequest:{
                    pageNum: 1,
                    pageSize: 10,
                    total:0,
                },
                pageResult:[],
                companyOneId:'',
                thirdParty:sessionStorage.getItem('thirdParty'),// 判断是否是从第三方进来的
                //上传文件
                fileList:[],
                fileTips:{
                    isShow:false,
                    failedCount: 0,
                    failedDataURL: null,
                    failedFilename: null,
                    successCount: 0,
                    totalCount: 0,
                },
                //修改弹窗
                rowData:{},
                dialogForm:{
                    open:false
                },
                dialogRules:{
                    mobilePhone:[
                        { validator: phoneNumber, trigger: 'blur'}
                    ]
                }
            };
        },
        methods: {
            nameClick:function (data) {
                sessionStorage.setItem('companyChange',JSON.stringify(data));
            },
            // 获取分页数据
            findPage: function (data) {
                var that = this;
                this.queryParam.companyId = that.companyOneId.id;
                this.queryParam.pageNum = this.pageRequest.pageNum;
                this.$api.mobile.findAccountList(this.queryParam).then((res) => {
                    if(res.status){
                        this.pageRequest.total = res.data.total;
                        this.pageResult = res.data.list;
                    }else{
                        this.$message({message: '操作失败, ' + res.msg, type: 'error'})
                    }
                    this.loading = false;
                }).then(data!=null?data.callback:'')
            },
            //修改按钮
            editClick(row){
                this.rowData = JSON.parse(JSON.stringify(row));
                this.dialogForm.open = true;
            },
            //修改弹窗确定
            editDialogSubmit:function(){
                this.$refs.dialogForm2.validate((valid) => {
                    console.log(valid)
                    if (valid) {
                        this.loading = true;
                        this.$api.mobile.updatePhone({
                            id:this.rowData.id,
                            phone:this.rowData.mobilePhone,
                        }).then((res) => {
                            if(res.status){
                                this.dialogForm.open = false;
                                this.loading = false;
                                this.$message({message: '操作成功！ ',type: 'success'});
                                this.findPage();
                            }else{
                                this.dialogForm.open = false;
                                this.loading = false;
                                this.$message({message: res.msg ,type: 'error'});
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            //查询
            onSearch(){
                this.fileTips= {
                    isShow:false,
                    failedCount: 0,
                    failedDataURL: null,
                    failedFilename: null,
                    successCount: 0,
                    totalCount: 0,
                };
                this.$refs.searchForm.validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        this.findPage();
                    } else {
                        return false;
                    }
                });
            },
            //分页点击事件
            refreshPageRequest(pageNum){
                this.pageRequest.pageNum = pageNum;
                this.findPage();
            },
            beforeAvatarUpload(file){
                // 限制上传格式
                let acceptList = ['xlsx','xls'];
                let fileType = file.name.split('.').pop().toLowerCase();
                if(acceptList.indexOf(fileType) === -1){
                    this.$message({message: '只能上传xlsx/xls格式的文件！ ', type: 'error'});
                    return false;
                }

                let formData = new FormData();//通过form数据格式来传
                formData.append("file", file); //传文件
                this.$api.mobile.uploadExcel(formData).then((res) => {
                    if(res.status){
                        this.salaryOrderId = res.data;
                        this.fileTips.failedCount = res.data.failedCount;
                        this.fileTips.failedFilename = res.data.failedFilename;
                        this.fileTips.successCount = res.data.successCount;
                        this.fileTips.totalCount = res.data.totalCount;
                        this.fileTips.isShow = true;
                        this.$message({message: '导入成功！ ', type: 'success'})
                        if(this.fileTips.successCount>0){
                            this.findPage();
                        }
                    }else{
                        this.$message({message: '导入失败, ' + res.msg, type: 'error'})
                    }
                });
            },
            //上传
            submitUpload() {
                this.$refs.upload.submit();
            },
            updataSuccess(res, file, fileList){
                //this.$message({message: '导入成功！ ',type: 'success'});
            },
            updataError(err, file, fileList){
                if(err.status != '403'){
                    this.$message({message: '导入失败！ ', type: 'error'})
                }
            },
            //下载导入失败数据
            downError(){
                this.$api.mobile.downloadErrorData({
                    url:this.fileTips.failedFilename
                }).then((res) => {
                    const aLink = document.createElement("a");
                    let blob = new Blob([res], {type: "application/vnd.ms-excel"})
                    aLink.href = URL.createObjectURL(blob)
                    aLink.setAttribute('download', '导入失败数据' + '.xlsx') // 设置下载文件名称
                    aLink.click()
                })
            },
            //批量导入模板下载
            downModel(){
                this.$api.mobile.downModel({
                }).then((res) => {
                    const aLink = document.createElement("a");
                    let blob = new Blob([res], {type: "application/vnd.ms-excel"})
                    aLink.href = URL.createObjectURL(blob)
                    aLink.setAttribute('download', '批量导入模板' + '.xlsx') // 设置下载文件名称
                    aLink.click()
                })
            }
        },
        mounted() {
            var that = this;
            window.addEventListener('setItemEvent',function(e){
                if(e.key == "companyChange"){
                    that.companyOneId = JSON.parse(e.newVal);
                    that.findPage(null);
                }else if(e.key == "companyOneId"){
                    that.companyOneId = JSON.parse(e.newVal);
                    that.findPage(null);
                }
            });
        },
    };
</script>

<style scoped>
    .demo-form-inline{
        text-align: left;
    }
</style>



// WEBPACK FOOTER //
// src/views/Mobile.vue